export const NURSE_TYPE = [2]; //2 - Practice Nurse
export const MEDICAL_TYPE = [0, 1, 3, 4]; //  0 - GP, 1 - GP Trainee, 3 - NCHD, 4 - Consultant
export const POSTCODE_COUNTRIES = [0, 1, 2, 4, 6, 7];
export const DOCTOR_TYPE = [0, 2, 3];
export const IRELAND = [3];



// WEBPACK FOOTER //
// ./src/modules/auth/containers/constants.js